import React, { useState, useEffect } from "react";
import System from 'src/helper/system';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import Helper from "../../helper/Helper";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import RoleAndPermission from "src/helper/RoleAndPermission";

const AddressInformation = () => {
    const { siteUser: { WEB, CORE }, addressType, shippingCarrierType: { AVNET } } = Constants
    const [{ profile_account_information }, { get_profile_account_information }, { set_account_address_default, profile_address_action }] = profileStore();
    const [invoiceAddress, setInvoiceAddress] = useState([])
    const [shippingAddress, setShippingAddress] = useState([])
    const { avUserInfoData: { currentUser, salesOrg, accountNumber } } = System
    const isWebAndCoreUser = currentUser === WEB || currentUser === CORE
    const isWebUser = currentUser === WEB
    const isCoreUser = currentUser === CORE
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const { translation: t } = System;
    const isRequestShippingPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.profilePermission.submit_req_for_address)
    const isAddEditAddressPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.profilePermission.add_edit_address)

    useEffect(() => {
        if (Object.keys(profile_account_information).length === 0) {
            get_profile_account_information();
        } else {
            const primaryAddress = profile_account_information?.shipTo?.filter((shipadd) => shipadd?.address?.addressType === Constants.PRIMARY)
            setShippingAddress((System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE) ? primaryAddress : profile_account_information?.shipTo) ?? []);

            setInvoiceAddress(profile_account_information?.billTo ?? []);
        }
    }, [profile_account_information]);

    const openInvoicePopup = (addressInfo) => {
        clear_all_system_alert()
        System.popup('ProfileAddressPopup', addressInfo);
    }

    const setDefaultAddress = async (id, isDefault, preferenceFilter = "", type = 'Default_ShipTo') => {
        clear_all_system_alert()
        const data = {
            "preferenceType": type,
            "preferenceValue": isDefault ? "" : id,
            "preferenceFilter": preferenceFilter
        };
        const res = await set_account_address_default(data);
        if (res) {
            system_alert_indicator({
                name: 'profile',
                message: isDefault ? type === 'Default_ShipTo' ? t('defaultShippingAddressHasBeenDeleted') : t('defaultShippingMethodHasBeenDeleted') : t('defaultShippingAddressHasBeenUpdated'),
                type: "success"
            })
            await get_profile_account_information();
            Helper.scrollTop();
        }
    };

    return (
        <>{__check("PROFILE_ACCOUNT_INFORMATION").status ? __check('PROFILE_ACCOUNT_INFORMATION').render :
            <>

                <div>
                    <div className='d-flex align-items-center justify-content-between profile-title mb-2'>
                        <div className='font-arial font-16'><b> {t('invoiceAddress')}</b></div>
                        <div>
                            {isAddEditAddressPermission && isWebUser && ((!Helper.valueIsNotNull(invoiceAddress)) || invoiceAddress?.length === 0)
                                && <a onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': {} })}
                                    className='font-arial'><b>
                                        <i className="fa fa-plus me-1"></i> {t('addInvoiceAddress')} </b>
                                </a>}
                        </div>
                    </div>
                    {currentUser === CORE &&
                        <p className="font-arial font-16 mb-3 pb-1">{t('contactToEditOrAddAddress')}</p>}
                    <div className='mb-4'>
                        <div className='profile-box-container'>
                            {invoiceAddress?.length > 0 && invoiceAddress.map((invoiceAdd, index) => (
                                ((isCoreUser && invoiceAdd.address?.addressType === Constants.PRIMARY && (profile_account_information?.customerNo === invoiceAdd?.id)) || (isWebUser)) &&
                                <div className='profile-box' key={index}>
                                    <div>
                                        <div className='companyname ps-0'><b>{invoiceAdd.companyName}</b></div>
                                        <div className='companyaddress'>
                                            {invoiceAdd.address.addressLineOne},<br />
                                            {invoiceAdd.address.addressLineTwo?.trim() && <>
                                                {invoiceAdd.address.addressLineTwo},<br />
                                            </>}
                                            {invoiceAdd.address.cityName}, {invoiceAdd.address.stateName} {invoiceAdd.address.postalCode}, <br />
                                            {invoiceAdd.address.countryName}.
                                        </div>
                                    </div>

                                    {isAddEditAddressPermission && isWebUser && <a onClick={() => openInvoicePopup({
                                        'type': addressType.BILL_TO,
                                        'addressInfo': invoiceAdd
                                    })}>{t('edit')}</a>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div>
                    <div className='d-flex align-items-center justify-content-between profile-title'>
                        <div className='font-arial font-16'><b> {t('shippingAddress')}</b></div>
                        <div>
                            <a onClick={() => openInvoicePopup({ 'type': addressType.SHIP_TO, 'addressInfo': {} })}
                                className='font-arial'><b>
                                    {isAddEditAddressPermission && isWebUser && <><i className="fa fa-plus me-1"></i> {t('addShippingAddress')} </>}
                                    {(isCoreUser && isRequestShippingPermission) && <><i className="fa fa-address-card" aria-hidden="true"></i> {t('requestShippingAddress')} </>}
                                </b></a>
                        </div>
                    </div>
                    <div className='mb-4'>
                        <div className='profile-box-container'>
                            {isWebAndCoreUser && shippingAddress?.length > 0 && shippingAddress?.map((shipadd, index) => {
                                return (
                                    <div className="profile-box-shipping-column" key={index}>
                                        <div className='profile-box-shipping'>
                                            <div className={`d-flex align-items-center justify-content-between set-default ${shipadd.default ? 'active' : ''}`}>
                                                {(shipadd.default) ? t('default') : t('setAsDefault')}
                                                <label className="whitecheckbox">
                                                    <input type='checkbox'
                                                        className='m-0 check'
                                                        checked={shipadd.default}
                                                        onChange={() => setDefaultAddress(shipadd.id, shipadd.default, isCoreUser ? `${salesOrg}-${accountNumber}` : "")} />
                                                    <span className="box"></span>
                                                </label>
                                            </div>
                                            <div className='profile-box'>
                                                <div className='mb-3'>
                                                    <div className='companyname ps-0'><b>{shipadd.companyName}</b></div>
                                                    <div className='companyaddress'>
                                                        {shipadd.address.addressLineOne},<br />
                                                        {shipadd.address.addressLineTwo?.trim() && <>
                                                            {shipadd.address.addressLineTwo},<br />
                                                        </>}
                                                        {shipadd.address.cityName}, {shipadd.address.stateName} {shipadd.address.postalCode}, <br />
                                                        {shipadd.address.countryName}.
                                                    </div>
                                                </div>

                                                {!System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE) && isAddEditAddressPermission && (
                                                    <div>
                                                        <a onClick={() => openInvoicePopup({ 'type': addressType.SHIP_TO, 'addressInfo': shipadd })}
                                                            className='font-arial'>{t('edit')}</a>  | {'  '}
                                                        <a onClick={() => System.popup("GuestPopupActionButton", {
                                                            title: t('deleteShippingAddress'),
                                                            body: t('confirmDeleteShippingAddress'),
                                                            yesButton: t('delete'), closeButton: t('cancel'),
                                                            shipadd: shipadd,
                                                            addressId: (e) => { return profile_address_action(e, 'Delete') },
                                                        })}
                                                            className='font-arial'>{t('delete')}</a>
                                                    </div>
                                                )}

                                                {System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr, WEB) && (
                                                    shipadd.default &&
                                                    <div>
                                                        <div><b>{t('shippingMethod')}</b></div>
                                                        <div>¥600 - {shipadd?.carrier?.carrierKey} </div>
                                                    </div>
                                                )}
                                                {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, CORE) && (
                                                    shipadd.default &&
                                                    <div>
                                                        <div><b>{t('shippingMethod')}</b></div>
                                                        <div>{shipadd?.carrier && shipadd?.carrier?.carrierKey}</div>
                                                    </div>
                                                )}
                                                   {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, WEB) && isAddEditAddressPermission && (
                                                    shipadd.default && (
                                                        shipadd.carrier === null ? (
                                                            <div>
                                                                <a onClick={() => System.popup('ShippingMethodPopup', { shipadd })}
                                                                    className='font-arial'><b>
                                                                        <i className="fa fa-plus me-1"></i>{t('addShippingMethod')}</b></a>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div><b>{t('shippingMethod')}</b></div>
                                                                {shipadd?.carrier?.errorMessage !== null ? (
                                                                    <div>{(shipadd?.carrier?.errorMessage).startsWith('At this time Avnet is') && t('carrierErrorMessage')}</div>
                                                                ) : (
                                                                    <>
                                                                        <div>{shipadd?.carrier?.carrierType === AVNET ? 'Avnet Carrier' : 'My Carrier'} - {shipadd?.carrier?.carrierType === AVNET ? shipadd?.carrier?.carrierKey : shipadd?.carrier?.carrierAccount}</div>
                                                                        <div>{shipadd?.carrier?.carrierType === AVNET ? shipadd?.carrier?.carrierOption : shipadd?.carrier?.carrierKey}</div>
                                                                        <a onClick={() => System.popup('ShippingMethodPopup', { carrier: shipadd?.carrier, shipadd })}
                                                                            className='font-arial'>{t('modify')}</a>  | {'  '}
                                                                        <a onClick={() => setDefaultAddress('', shipadd.default, '', 'Default_Carrier')}
                                                                            className='font-arial'>{t('remove')}</a>
                                                                    </>
                                                                )}
                                                            </div>
                                                        )
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </>
        }
        </>
    );
};

export default AddressInformation;
